module.exports = [
    { value: 'desc', label: 'absteigend (übermorgen, morgen, heute)' },
    { value: 'asc',  label: 'aufsteigend (heute, morgen, übermorgen)' },
];
